import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import NotFoundPage from './pages/NotFoundPage';
import ErpPage from './pages/ErpPage';
import ZartooAppPage from './pages/ZartooAppPage';
import AppB2BPage from './pages/AppB2BPage';
import PdvPage from './pages/PdvPage';
import CasosSucessoPage from './pages/CasosSucessoPage';
import PlanosPage from './pages/PlanosPage';
import FaqPage from './pages/FaqPage';
import SuportePage from './pages/SuportePage';
import BlogPostPage from './pages/BlogPostPage';
import MateriaisPage from './pages/MateriaisPage';
import DemonstracaoPage from './pages/DemonstracaoPage';
import EspecialistaPage from './pages/EspecialistaPage';
import PrivacidadePage from './pages/PrivacidadePage';
import TermosPage from './pages/TermosPage';
import SitemapPage from './pages/SitemapPage';
import ObrigadoDemonstracaoPage from './pages/ObrigadoDemonstracaoPage';
import ObrigadoContatoPage from './pages/ObrigadoContatoPage';
import ObrigadoDownloadPage from './pages/ObrigadoDownloadPage';

export default function App() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="bg-slate-950 text-white min-h-screen">
      {!isHome && <Navbar />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contato" element={<ContactPage />} />
        <Route path="/wibi-erp" element={<ErpPage />} />
        <Route path="/zartoo-app" element={<ZartooAppPage />} />
        <Route path="/app-b2b" element={<AppB2BPage />} />
        <Route path="/sistema-pdv" element={<PdvPage />} />
        <Route path="/casos-sucesso" element={<CasosSucessoPage />} />
        <Route path="/planos" element={<PlanosPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/suporte" element={<SuportePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/materiais" element={<MateriaisPage />} />
        <Route path="/demonstracao" element={<DemonstracaoPage />} />
        <Route path="/especialista" element={<EspecialistaPage />} />
        <Route path="/privacidade" element={<PrivacidadePage />} />
        <Route path="/termos" element={<TermosPage />} />
        <Route path="/mapa-do-site" element={<SitemapPage />} />
        <Route path="/obrigado-demonstracao" element={<ObrigadoDemonstracaoPage />} />
        <Route path="/obrigado-contato" element={<ObrigadoContatoPage />} />
        <Route path="/obrigado-download" element={<ObrigadoDownloadPage />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!isHome && <Footer />}
    </div>
  );
}
